/**
 * @author chaixianguo
 * @date 2025-08-15
 */
<template>
    <section class="home-content" id="home-content">
        <swiper class="swiper" 
        v-if="imglist && imglist.length > 1"
          :options="swiperOption"
        >
          <swiper-slide 
          v-for="(item,index) in imglist" :key="index">
            <img :src="item" alt=""/>
          </swiper-slide>
          <!-- <div class="swiper-pagination" slot="pagination"></div> -->
          <!-- <div class="swiper-button-prev" slot="button-prev"></div>
          <div class="swiper-button-next" slot="button-next"></div> -->
        </swiper>
        <div v-else class="swiper">
           <img v-if="imglist && imglist[0]" :src="imglist[0]" alt=""/>
        </div>
       
        <div class="code-img">
          <div class="code-img-box">
            <img src="/imgs/gzh.jpg" alt="" srcset="">
            <div class="code-title" style="font-weight: bold;">ONE运动</div>
            <div class="code-title">公众号</div>
          </div>
           <div class="code-img-box">
            <img src="/imgs/fyjh.jpg" alt="" srcset="">
             <div class="code-title" style="font-weight: bold;">ONE运动羽毛球</div>
            <div class="code-title">小程序</div>
          </div>
          <div class="code-img-box">
            <img src="/imgs/jfb.jpg" alt="" srcset="">
             <div class="code-title" style="font-weight: bold;">羽毛球记分</div>
            <div class="code-title">小程序</div>
          </div>
         
        </div>
    </section>
</template>

<script>
 import { Swiper, SwiperSlide } from 'vue-awesome-swiper'
 import request from '@/utils/request'
 
import 'swiper/css/swiper.css'
export default {
  name: 'DashboardHome',
  components: {
    Swiper,
    SwiperSlide
  },
  props: {},
  data() {
    return {
      imglist:[
      
      ],
      swiperOption: {
          spaceBetween: 30,
          autoplay: {
            delay: 2500,
            disableOnInteraction: false
          },
          // pagination: {
          //   el: '.swiper-pagination',
          //   clickable: true
          // },
          loop: true
          // navigation: {
          //   nextEl: '.swiper-button-next',
          //   prevEl: '.swiper-button-prev'
          // }
        }
    };
  },
  methods: {
    async getList() {
      try {
        const response = await request({
          url: '/advertisement/getListByPosition',
          method: 'get',
          params: { adPosition: 'PortalBackgroud' } // URL 参数
        })
        this.imglist = response.data
      } catch (error) {
        console.error('获取列表失败:', error)
      }
    },
  },
  created() {
    this.getList()
  }
}
</script>

<style>
  .home-content{
    min-width: 1000px;
    width: 70vw;
    box-sizing: border-box;
    background: #FFF;
    border-radius: 10px;
    padding:20px;
    height: calc(100vh - 80px);
    margin-top: 10px
  }
  .home-content .code-img{
    padding: 30px 0;
    display: flex;
    justify-content: center;
  }
  .home-content .code-img .code-img-box{
    width: 140px;
    padding:0 100px
  }
  .home-content .code-img .code-img-box img{
    width: 100%;
  }
  .home-content .code-img .code-img-box  .code-title{
    text-align: center;
  }
  .swiper {
      height: calc(100% - 220px);
      overflow: hidden;
      width: 100%;
    /* border: 1px transparent solid; */
  }
  .swiper-slide {
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;
    font-weight: bold;
    font-size: 14px;
   position: relative;
    /* background-color: rgb(98, 168, 200); */
  }
  /* .swiper-slide::after{
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: linear-gradient(0deg, rgba(0, 0, 0, 0.50) 0%, rgba(0, 0, 0, 0.50) 100%)
  } */
  .swiper img{
     height: 100%;
     aspect-ratio:16/9;
     object-fit: cover
  }
</style>